import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1.91px;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 1.5,
			y: 1.5,
			width: 21,
			height: 21,
			rx: 1.91
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "5.32 6.27 5.32 13.91 7.23 13.91 7.23 15.82 10.09 15.82 10.09 17.73 13.91 17.73 13.91 15.82 16.77 15.82 16.77 13.91 18.68 13.91 18.68 6.27 5.32 6.27"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 8.18,
			y1: 9.14,
			x2: 8.18,
			y2: 6.27
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12,
			y1: 9.14,
			x2: 12,
			y2: 6.27
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15.82,
			y1: 9.14,
			x2: 15.82,
			y2: 6.27
		})
	]
});
export default SvgPort;
